<template>
  <div>
    <!--详情页加盟弹框-->
    <el-dialog
      title="邀请加盟"
      :visible.sync="InvitedVisible"
      @closed="resetInvitedForm()"
      :close-on-click-modal="false"
    >
      <el-form :model="InvitedForm" ref="InvitedForm" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="邀请单位：" label-width="120px">
              <span>{{InvitedForm.companyName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="我的企业：" label-width="120px">
              <span>{{$store.state.user.companyName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人：" prop="contacts" label-width="120px">
              <el-input
                v-model="InvitedForm.contacts"
                placeholder="请输入联系人"
                oninput="if(value.length>20)value=value.slice(0,20)"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" placeholder="请输入联系电话" prop="phone" label-width="120px">
              <el-input v-model="InvitedForm.phone" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="需求描述：" label-width="120px" prop="inviteContent">
              <el-input
                type="textarea"
                maxlength="300"
                placeholder="请输入需求描述"
                :rows="3"
                v-model="InvitedForm.inviteContent"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            v-for="(item,index) in InvitedForm.paramDtos"
            :key="index"
          >
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :prop="'paramDtos.'+ index + '.title'"
                  label-width="120px"
                  :rules="{required: true, message: '您未输入任何内容', trigger: 'blur'}"
                >
                  <el-input maxlength="10" placeholder="请输入" v-model="item.title"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="13" style="margin-left: 10px">
                <el-form-item
                  :prop="'paramDtos.'+ index + '.content'"
                  :rules="{required: true, message: '您未输入任何内容', trigger: 'blur'}"
                >
                  <el-input maxlength="300" placeholder="请输入内容" v-model="item.content"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" style="margin-left: 10px">
                <el-button @click.prevent="removeParamDtos(index)">删除</el-button>
              </el-col>
            </el-row>
            <div class="tc-10"></div>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <div class="tc-10"></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="disabled" @click="addField()">新增字段</el-button>
        <el-button @click="resetInvitedForm()">取 消</el-button>
        <el-button type="primary" :disabled="disabled" @click="submitForm('InvitedForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiHome } from '@/api/apiHome'
export default {
  data () {
    return {
      disabled: false,
      rules: {// 验证规则
        contacts: [
          { required: true, trigger: 'blur', validator: this.validConsigneeName }
        ],
        address: [
          { required: true, trigger: 'blur', validator: this.validAddress }
        ],
        phone: [
          { required: true, trigger: 'blur', validator: this.validPhone },
          { min: 11, max: 11, message: '请输入正确的11位手机号码', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入标题名称', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    InvitedVisible: {
      type: Boolean,
      default: false
    },
    InvitedForm: {
      type: Object,
      default: () => {}
    },
    remoteClose: Function // 接收父组件关闭弹窗方法
  },
  components: {},

  methods: {
    /** @name 新增一行表单 */
    addField () {
      if (this.InvitedForm.paramDtos.length > 4) {
        this.$message({
          message: '最多只能添加五条！',
          type: 'warning'
        })
      } else {
        let obj = {
          content: '',
          title: ''
        }
        this.InvitedForm.paramDtos.push(obj)
      }
    },
    /** @name 删除当前行 */
    removeParamDtos (i) {
      this.InvitedForm.paramDtos.splice(i, 1)
    },
    /** @name 关闭弹窗 */
    resetInvitedForm () {
      this.$refs['InvitedForm'].resetFields()
      this.remoteClose()
    },
    /** @name 提交表单 */
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.disabled = true
          let res = await apiHome.InvitedForm(this.InvitedForm)
          if (res.data.code === 0) {
            this.$message.success('提交邀请成功')
          } else {
            this.$message.error(res.data.msg)
          }
          this.resetInvitedForm()
          this.disabled = false
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
